import React from 'react';
import SolutionRequestEstimateBeamContainer from 'containers/SolutionRequestEstimateBeamContainer';

export default function SolutionRequestEstimateBeamPage() {
    return (
        <SolutionRequestEstimateBeamContainer />
    )
}
